// Shared display formatting for the dashboard — used by both real financials
// data and the AUM/orders preview widgets. Not mock data itself.

export const formatCompactNumber = (value) => {
  const abs = Math.abs(value);
  if (abs >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (abs >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return String(Math.round(value));
};

const CURRENCY_SYMBOLS = { AED: '', USD: '$', EUR: '€', GBP: '£' };

export const formatCurrencyCompact = (value, currency = 'AED') =>
  `${CURRENCY_SYMBOLS[currency] ?? `${currency} `}${formatCompactNumber(value)}`;

// Below this, "compact" still shows the exact amount (e.g. "AED 201.36") so the
// dashboard reads the same figure the Portfolio page shows for small books.
const COMPACT_THRESHOLD = 10000;

const toFinite = (value) => {
  const n = typeof value === 'number' ? value : Number.parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Format an amount with its ISO currency code, e.g. "AED 201.36" or "USD 1.2M".
 * The currency code is always the real currency of the figure — never assume AED.
 */
export const formatMoney = (value, currency = 'AED', { compact = false } = {}) => {
  const n = toFinite(value);
  const code = currency || 'AED';
  if (compact && Math.abs(n) >= COMPACT_THRESHOLD) return `${code} ${formatCompactNumber(n)}`;
  return `${code} ${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatAed = (value, options) => formatMoney(value, 'AED', options);
